import { ReduxService } from 'dashboard-services/services'

import reviewDatalakeActions from 'actions/modules/datalake/review'

export const reviewInitialState = {
  identity: null,
  commentTargets: {},
  commentOutputTargets: undefined,
  commentGeometryVersion: 0,
  comments: { activeLocation: null, selectedIndex: null, temporary: {}, minimized: [], preview: null, isWriting: false },
  isSidebarVisible: true,
  wrap: false,
  collapsedSections: [],
  showAllSections: []
}

export default (state = reviewInitialState, action) => {
  switch (action.type) {
    case reviewDatalakeActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state
    }
    case reviewDatalakeActions.RESET:
      return reviewInitialState
    default:
      return state
  }
}
